import Vue from 'vue';

Vue.directive('scroll-to', {
  bind(el, binding) {
    const selector = binding.value;

    el.addEventListener('click', () => {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    });
  }
});